import * as React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {CoachInfoCard} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {getDateUtilDefaultInstance} from '/util/date.util';

import {styles} from './EarnedBonusReportContent.style';
interface RecordData {
  earnedOn: string;
  newOrderingEntitiesCount: number;
  fqv: number | string;
}
interface Props {
  recordData: RecordData;
  fqvName: string;
  bonusTitle: string;
}

export const EarnedBonusReportContent: React.FC<Props> = ({
  recordData: {earnedOn, newOrderingEntitiesCount, fqv},
  fqvName,
  bonusTitle,
}) => {
  const {tt} = useTranslation('reportCardContent.earnedBonus');

  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">{bonusTitle}</Text>
        </Gutter>
      </View>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly
          label={<Text>{tt('earnedOn', 'Earned on')}</Text>}
          suffix={
            <Text variant="button">
              {getDateUtilDefaultInstance().formatDate(
                earnedOn,
                'MMMM d, yyyy',
              )}
            </Text>
          }
          testID={CoachInfoCard.earnedOnContent}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly
          label={<Text>{fqvName}</Text>}
          suffix={<Text variant="button">{parseInt(fqv as string, 10)}</Text>}
          testID={CoachInfoCard.fqvContent}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly
          label={
            <Text>
              {tt('totalNewOrderingEntities', 'Total New Ordering Entities')}
            </Text>
          }
          suffix={<Text variant="button">{newOrderingEntitiesCount}</Text>}
          testID={CoachInfoCard.oeContent}
        />
      </Gutter>
    </View>
  );
};
